import {get_query_arg_all, isDomElementVisible} from '../js_common/_dzs_helpers';
import {
  DZSWTL_FILTERS_CUSTOMTAX,
  DZSWTL_FILTERS_CUSTOMTAX_PRODUCT_ATTRIBUTE,
  DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY
} from "../config/_dzswtl_constants";

export class DzswtlFilter {

  constructor(DzswtlInstance) {

    this.DzswtlInstance = DzswtlInstance;

    this.init();
  }


  init() {

    let woo_search_inter = 0;
    var $ = jQuery;
    let FiltersInstance = this;
    let feed_from_arr = {}; // -- feed_from_arr is based on data-dzs-woo-feed-lab


    var selfClass = this.DzswtlInstance;




    $('.dzs-woo-feed-filter-obj').each(function () {
      var _t = $(this);

      feed_from_arr[_t.attr('data-dzs-woo-feed-lab')] = _t.attr('data-dzs-woo-feed-type');
    })

    jQuery(document).off('change.dzswtlSingleton');



    $(document).on('change.dzswtl', '.dzs-woo-table-filter-input:not(.dzs-select-wrapper), select.attribute-selector, *[name="woo_sort"]', handle_change);
    $(document).on('click.dzswtl', '.dzs-woo-table-filter-for-click', handle_change);
    $(document).on('keyup.dzswtl', '*[name="woo_search"]', handle_change);



    function woo_search(arg) {
      var args = {};

      var $wooSearch = $('*[name=woo_search]');

      if ($wooSearch.eq(0).val()) {

      }
      args['search'] = $wooSearch.eq(0).val();
      args['call_from'] = 'searcher';
      args['caller_event'] = 'FILTER_SEARCH_EVENT';


      selfClass.load_new_content(args)
    }

    function handle_change(e) {
      // -- @handle a filter change or a sort change

      var _t = $(this);


      setTimeout(function () {

        FiltersInstance.dzswtl_filter_from_reinit();
      }, 500);

      if (window.dzswtl_block_changes) {
        return false;
      }

      if (e.type === 'keyup') {

        if (_t.attr('name') === 'woo_search') {

          clearTimeout(woo_search_inter);


          woo_search_inter = setTimeout(woo_search, 700, _t.val());

        }
      }
      if (e.type === 'click') {


        if (_t.hasClass('dzs-woo-table-filter-for-click')) {
          var _con = _t.parent();

          var _filter_from = _con.find('.dzs-woo-feed-filter-from').eq(0);


          var lab = _filter_from.attr('data-dzs-woo-feed-lab');

          var args = {};

          if (_t.hasClass('active')) {

            _t.parent().children().removeClass('active');
            args[lab] = '';
            args['caller_event'] = 'FILTER_CLICK_EVENT';
            selfClass.load_new_content(args)
          } else {


            _t.parent().children().removeClass('active');
            _t.addClass('active');


            args[lab] = _t.attr('data-term-slug');
            args['caller_event'] = 'FILTER_CLICK_EVENT';
            selfClass.load_new_content(args)
          }


        }
      }
      if (e.type === 'change') {

        if (_t.attr('name') === 'woo_sort') {
          // -- only for sorting


          var args = {};

          var val = String(_t.val());
          args['sort_by'] = val;
          args['caller_event'] = 'FILTER_SORT_EVENT';
          selfClass.load_new_content(args)

          // -- only for sorting END
        }


        // -- filter input
        if (_t.hasClass('attribute-selector')) {


          var val = _t.val();


          var _c = _t.find(':selected');


          if (_c.attr('data-price')) {


            if (_t.parent().parent().parent().parent().find('.price-highlight').length) {
              _t.parent().parent().parent().parent().find('.price-highlight > .the-price-number').eq(0).html(_c.attr('data-price'));
            }
          }
        }


        // -- filter input
        if (_t.hasClass('dzs-woo-table-filter-input')) {

          if (_t.attr('type') === 'checkbox') {
          }


          var lab = _t.attr('name');

          var lab_sanitized_no_arr = lab;


          try {
            lab_sanitized_no_arr = lab.replace('[]', '');
          } catch (err) {

          }


          var seek_lab = '';
          var seek_type = '';

          for (let key in feed_from_arr) {

            if (lab_sanitized_no_arr === key) {
              seek_lab = key;
              seek_type = feed_from_arr[key];
              break;
            }
          }


          if (seek_type === '' || seek_type === 'none') {
            seek_type = 'select';
          }


          var vals = '';

          if (seek_type === 'multiple') {

            $('*[name="' + lab + '"]').each(function () {
              var _t2 = $(this);


              if (_t2.attr('type') === 'checkbox') {
                if (_t2.prop('checked')) {
                  if (vals) {
                    vals += ',' + _t2.val();
                  } else {

                    vals += '' + _t2.val();
                  }
                }
              }

            })
          }


          if (seek_type === 'select' || seek_type === 'slider') {

            $('*[name="' + lab + '"]').each(function () {
              var $filter = $(this);


              // -- select .. single val


              let $visibilityChecker = $filter;

              if (seek_type === 'slider') {
                $visibilityChecker = $filter.parent();
              }

              if (dzswtl_settings.filter_check_if_visible === 'on') {
                if ($visibilityChecker.hasClass('dzs-style-me') || isDomElementVisible($visibilityChecker.get(0))) {
                  vals = $filter.val();
                }
              } else {

                vals = $filter.val();
              }
            })
          }
          if (seek_type === 'input') {

            var $filter = $('*[name="' + lab + '"]');


            if (dzswtl_settings.filter_check_if_visible === 'on') {
              if (isDomElementVisible($filter.get(0))) {
                vals = $filter.val();
              }
            }


          }


          let loadNewContentArgs = {};

          loadNewContentArgs[lab_sanitized_no_arr] = vals;


          if (window.dzswtl_collect_args_in_timeout) {
            window.dzswtl_collect_args = $.extend(window.dzswtl_collect_args, loadNewContentArgs);
            for (let labLoop in loadNewContentArgs) {
              window.dzswtl_collect_args[labLoop] = loadNewContentArgs[labLoop];
            }
          }

          // -- end group
          loadNewContentArgs.call_from = 'filter-input';


          loadNewContentArgs['caller_event'] = 'FILTER_CHANGE_EVENT';
          selfClass.load_new_content(loadNewContentArgs);
        }
      }
    }


  }

  dzswtl_filter_from_reinit() {

    var $ = jQuery;

    $('.dzs-woo-feed-filter-from').each(function () {
      var _t2 = $(this);


      if (_t2.attr('data-dzs-woo-term-parent') === 'auto') {

        var _woofilter = _t2.parent();


        var _feed = $('.dzs-woo-feed[data-dzs-woo-term-parent="0"]').eq(0).parent().find('.dzs-woo-table-filter-input:not(.dzs-select-wrapper)').eq(0);

        var feedval = _feed.val();


        if (feedval) {


          if (feedval !== _feed.data('last_feedval')) {


            $.ajax({
              async: "false",
               method: "POST",
              url: window.dzswtl_settings.admin_url + '?dzswtl_action=load_subcats',
              data: {
                hmm: 'ceva',
                postdata: feedval
              },
              dataType: 'html',
              success: function (response) {


                var dataarr = [];
                try {
                  dataarr = JSON.parse(response);

                  let newSelectHtml = '';

                  newSelectHtml += '<option value="">' + _woofilter.find('.label-all').text() + '</option>';
                  for (var i = 0; i < dataarr.length; i++) {

                    newSelectHtml += '<option ';


                    if (get_query_arg(window.location.href, 'subcat') === dataarr[i].slug) {
                      newSelectHtml += ' selected';
                    }


                    newSelectHtml += ' value="' + dataarr[i].slug + '">' + dataarr[i].name + '</option>';
                  }
                  _woofilter.find('.dzs-select-wrapper select').html(newSelectHtml);


                  setTimeout(function (_woofilter) {

                    _woofilter.find('.dzs-select-wrapper select').get(0).api_recheck_value_from_input();


                  }, 500, _woofilter);
                } catch (err) {
                  console.warn(err);
                }
              }
            })


            _feed.data('last_feedval', feedval);
          }


        } else {
          _woofilter.find('.dzs-select-wrapper-head .the-text').html(_woofilter.find('.label-auto-empty').html());
        }
      }
    });
  }

  static constructAjaxCall(selfClass, margs, pageOptions) {

    var argsCurrentFilters = {};
    window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY] = window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY].replace(/{{escape}}/g, '\\');
    try {
      argsCurrentFilters = JSON.parse(window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY]);
    } catch (err) {
      console.info('json parse error - ', window[DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY]);
      console.error(err)
    }

    if (margs.table_paged) {
      margs.paged = margs.table_paged;
    }


    argsCurrentFilters = jQuery.extend(argsCurrentFilters, margs);

    for (let lab in argsCurrentFilters) {
      var val = argsCurrentFilters[lab];

      if (val === 'wtn-wtn') {
        delete argsCurrentFilters[lab];
      }
    }


    for (let lab in selfClass['hardCodedKeys']) {
      argsCurrentFilters[lab] = selfClass['hardCodedKeys'][lab];
    }


    if (selfClass.cthis.attr('data-post-id')) {
      argsCurrentFilters.called_from_post_id = selfClass.cthis.attr('data-post-id');
    }


    argsCurrentFilters.return_only_items = "on";
    argsCurrentFilters.page_url = window.location.href;

    if (argsCurrentFilters.call_from === 'filter-input' || argsCurrentFilters.call_from === 'searcher') {
      selfClass.cthis.attr('data-random-posts', '');
    }

    if (selfClass.cthis.attr('data-random-posts')) {
      argsCurrentFilters.ids = selfClass.cthis.attr('data-random-posts');
      argsCurrentFilters.paged = Number(selfClass.cthis.attr('data-curr_paged')) + 1;

      if (pageOptions['pages_curr'] >= pageOptions['pages_max']) {
        console.info('no more random content');
        return false;
      }
    }

    return argsCurrentFilters;
  }


  reinitFilters() {

    var selfClass = this.DzswtlInstance;
    var $ = jQuery;
    let FiltersInstance = this;
    if (selfClass.actualSearch_forceUpdateFilters && Object.keys(selfClass.actualSearch_forceUpdateFilters).length) {
      for (var key in selfClass.actualSearch_forceUpdateFilters) {
        const $filter = $('.dzs-woo-table-filter-input[name="' + key + '"]').eq(0);
        $filter.val(selfClass.actualSearch_forceUpdateFilters[key]);

        if ($filter.get(0) && $filter.get(0).api_recheck_value_from_input) {
          $filter.get(0).api_recheck_value_from_input()
        }
      }

      selfClass.actualSearch_forceUpdateFilters = {};
    }


    setTimeout(function () {

      FiltersInstance.dzswtl_filter_from_reinit();
    }, 500);


    this.dzswtl_filter_from_reinit();
  }


}